import { render, staticRenderFns } from "./gwyg.vue?vue&type=template&id=4f6b4e70&scoped=true&"
import script from "./gwyg.vue?vue&type=script&lang=js&"
export * from "./gwyg.vue?vue&type=script&lang=js&"
import style0 from "./gwyg.vue?vue&type=style&index=0&id=4f6b4e70&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6b4e70",
  null
  
)

export default component.exports